import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { UserProfileEntity } from '@ppl/graphql-user-api';
import type { Space } from '@ppl/graphql-user-api';

@Component({
    selector: 'ppl-top-navigation-user-menu',
    templateUrl: './top-navigation-user-menu.component.html',
    styleUrls: ['./top-navigation-user-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TopNavigationUserMenuComponent {
  @Input() userProfile: UserProfileEntity;
  @Input() currentSpace: Space | null = null;
  @Input() selectSpaceUrl: string | null;
  @Input() userSettingsUrl: string;
  @Input() userSettingsRouterLink?: string;
  @Input() enableSpaceSettings = false;

  @Output() openSpaceSettings = new EventEmitter();

  logoutHref = `${window.location.origin}/logout`;
}
